import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import { store } from './state';

import AuthService from './services/authService';
import { publicRoutes } from './routes/appRouteList';
import { routeComparator } from './utils/navigationHelpers';
import { updateUserLoginStatus } from './state/features/userSlice';
import { ApiStatus } from './utils/enums';
import App from './App';

import './assets/CSS/index.css';

const isPublicRoute = routeComparator(Object.values(publicRoutes), window.location.pathname);
if (isPublicRoute === false) {
    sessionStorage.setItem('networkInsightsRedirectUrl', `${window.location.pathname}${window.location.search}`);
} else if (window.location.pathname === '/') {
    sessionStorage.setItem('networkInsightsRedirectUrl', publicRoutes.root);
}

// Initialize the AuthService
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
(async function initialize() {
    // eslint-disable-next-line no-async-promise-executor
    await new Promise(async (resolve) => {
        AuthService.initialize();

        store.dispatch(updateUserLoginStatus(ApiStatus.Loading));

        // Lift the gate and let the app navigate to correct page.
        // eslint-disable-next-line no-promise-executor-return
        return resolve(true);
    });
}());

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
